import { render } from "./footer.vue?vue&type=template&id=53098b10&scoped=true"
const script = {}

import "./footer.vue?vue&type=style&index=0&id=53098b10&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53098b10"]])

export default __exports__